// Dependencies
import { FC } from "react";

// Components
import LoginForm from "~/containers/LoginForm";

// Styles
import { StyledLoginBackground, StyledFormPosition } from "./Login.styled";

interface LoginProps {}

const Login: FC<LoginProps> = () => {
  return (
    <StyledLoginBackground>
      <StyledFormPosition>
        <LoginForm />
      </StyledFormPosition>
    </StyledLoginBackground>
  );
};

export default Login;
